/**
 * Picks v2 or v1 of the Media Resources page based on the redesign flag.
 */
import React from 'react';
import { useRedesignFlag } from '../../../utils/redesignFlag';
import MediaResource   from './MediaResource';
import MediaResourceV2 from './v2/MediaResourceV2';

export default function MediaResourceSwitch(props) {
  const [v2] = useRedesignFlag();
  const Component = v2 ? MediaResourceV2 : MediaResource;
  return <Component {...props} />;
}
